export default __webpack_public_path__ + "static/media/dphns_small_thumbnail_website_4.11a24759.jpg";